import { query } from "./graph";
import { useQuery } from "@apollo/client";
import { useRouter } from "found";
import AppBar from "../../../components/AppBar";
import ProductionAppWithSidebar from "../../../components/ProductionAppWithSidebar";
import React, { useCallback, useState } from "react";

const ORDERS_PER_PAGE = 25;

const HDDPressApp = ({ backUrl, appBarBackgroundColor }) => {
  const [searchQuery, setSearchQuery] = useState(null);
  const { router } = useRouter();

  const { data, loading, error, fetchMore } = useQuery(query, {
    variables: {
      first: ORDERS_PER_PAGE,
      filters: {
        searchQuery: searchQuery
      },
      runQuery: !!(searchQuery && searchQuery.trim().length > 0)
    },
    fetchPolicy: "network-only"
  });

  const handleSearchQuerySubmit = useCallback(query => {
    setSearchQuery(query);
  }, []);

  const handleAppBarRequestBack = useCallback(() => {
    router.push(backUrl || "/apps");
  }, [router, backUrl]);

  return (
    <ProductionAppWithSidebar
      data={data}
      destinationRoute="/apps/production/hdd-press/orders"
      errorMessage={error ? error.message : null}
      fetchMore={fetchMore}
      loading={loading}
      ordersConnection={data?.ordersConnection}
    >
      <AppBar
        title="HDD Pressing"
        onSearch={handleSearchQuerySubmit}
        onRequestBack={handleAppBarRequestBack}
        backgroundColor={appBarBackgroundColor}
      />
    </ProductionAppWithSidebar>
  );
};

export default HDDPressApp;
